import { type CSSProperties } from 'react';

import { isSafari } from '../../../../core/utils/user-agent-utils.js';
import { Tooltip } from '../../../../overlays/tooltip/Tooltip.js';

interface TickWithTruncationForeignObjectProps {
  x: number;
  y: number;
  style: CSSProperties;
  height: number | string;
  width: number | string;
  tickClassName: string | undefined;
  tickInlineStyle: CSSProperties;
  formattedValue: string;
  displayValue: string | undefined;
  showTooltip: boolean;
}

export function TickWithTruncationForeignObject({
  x,
  y,
  style,
  height,
  width,
  tickClassName,
  tickInlineStyle,
  formattedValue,
  displayValue,
  showTooltip,
}: Readonly<TickWithTruncationForeignObjectProps>) {
  return (
    <foreignObject x={x} y={y} style={style} height={height} width={width}>
      {isSafari() ? (
        <div
          className={tickClassName}
          style={tickInlineStyle}
          title={formattedValue}
        >
          {displayValue}
        </div>
      ) : (
        <Tooltip disabled={showTooltip} text={formattedValue}>
          <div className={tickClassName} style={tickInlineStyle}>
            {displayValue}
          </div>
        </Tooltip>
      )}
    </foreignObject>
  );
}
